import { render, staticRenderFns } from "./RedmineTrackerCombobox.vue?vue&type=template&id=b118f9b2&scoped=true"
import script from "./RedmineTrackerCombobox.vue?vue&type=script&lang=js"
export * from "./RedmineTrackerCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b118f9b2",
  null
  
)

export default component.exports